import React, { FunctionComponent, SVGProps } from 'react';
import { SuccessfulAction } from '../SuccessfulAction';
import Modal from 'features/app/components/Modal';

type SuccessfulActionModalProps = {
  closeButton?: boolean;
  onClose: () => void;
  onSuccessfulAction?: () => void;
  title?: string;
  open: boolean;
  dialogContentClass?: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>;
};

export const SuccessfulActionModal: React.FC<SuccessfulActionModalProps> = ({
  open,
  onClose,
  icon,
  title,
  dialogContentClass,
  onSuccessfulAction,
}) => {
  return (
    <Modal onClose={onClose} open={open} dialogContentClass={dialogContentClass}>
      <SuccessfulAction title={title} onSuccessfulAction={onSuccessfulAction} icon={icon} />
    </Modal>
  );
};
